import translation from "../translations/en.json";

export default function useTranslation() {
  return translation;
}
